module.exports = (__webpack_public_path__ || '') + "static/images/AppGalleryText-2472cd41ba2203cf2ecca2c9fc97f9fe.svg";